import { useState } from "react";
import { useVisitor } from "@/context/VisitorContext";
import { useI18n } from "@/context/I18nContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { cl } from "@/i18n/directory";

export function VisitorAuthModal() {
  const { authOpen, setAuthOpen, login, register } = useVisitor();
  const { lang } = useI18n();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      if (mode === "login") await login(f.email, f.password);
      else await register({ ...f, lang });
      toast.success(cl(lang, "favWelcome"));
      setAuthOpen(false);
      setF({ name: "", email: "", password: "" });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={authOpen} onOpenChange={setAuthOpen}>
      <DialogContent className="sm:max-w-md" data-testid="visitor-auth-modal">
        <DialogHeader>
          <DialogTitle className="font-head">{cl(lang, mode === "login" ? "favLogin" : "favRegister")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-sm text-muted-foreground -mt-1">{cl(lang, "favLoginPrompt")}</DialogDescription>
        <div className="space-y-3 mt-1">
          {mode === "register" && (
            <div><Label className="mb-1 block text-sm">{cl(lang, "favName")}</Label>
              <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="visitor-name" className="rounded-xl" /></div>
          )}
          <div><Label className="mb-1 block text-sm">{cl(lang, "favEmail")}</Label>
            <Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="visitor-email" className="rounded-xl" /></div>
          <div><Label className="mb-1 block text-sm">{cl(lang, "favPassword")}</Label>
            <Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} onKeyDown={(e) => e.key === "Enter" && submit()} data-testid="visitor-password" className="rounded-xl" />
            <p className="text-xs text-muted-foreground mt-1">{cl(lang, "favPwdHint")}</p></div>
          <Button className="w-full rounded-full bg-[#2C4234] hover:bg-[#3A5644]" disabled={busy} onClick={submit} data-testid="visitor-submit">
            {cl(lang, mode === "login" ? "favLogin" : "favRegister")}
          </Button>
          <button type="button" className="text-sm text-[#4E6E58] hover:underline w-full text-center" onClick={() => setMode(mode === "login" ? "register" : "login")} data-testid="visitor-toggle-mode">
            {cl(lang, mode === "login" ? "favToRegister" : "favToLogin")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
